module.exports = __webpack_public_path__ + "57e4ea5f93bf3d04287f7d14bf35698a.fbx";